import React from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

import Layout from '~/src/components/layout/Layout';
import Link from '~/src/components/link/Link';

import initPolyglot from '~/src/utilities/libs/polyglot';
import {getCategoryUrl} from '~/src/utilities/helpers/link';

import css from './_error.module.scss';
import i18nStrings from './_error.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const {publicRuntimeConfig: config} = getConfig();

const getText = ({statusCode, raw = {}}) => {
    const code = `${statusCode || raw.statusCode}`;

    switch (code) {
        case '404':
            return {
                title: 'error404.title',
                subtitle: 'error404.subtitle',
                description: 'error404.description'
            };
        case '410':
            return {
                title: 'error410.title',
                subtitle: 'error410.subtitle',
                description: 'error410.description'
            };
        default:
            return {
                title: 'errorGeneralTitle',
                subtitle: 'errorGeneralSubtitle',
                description: 'description'
            };
    }
};

const Error = (props) => {
    const text = getText(props);

    return (
        <React.Fragment>
            <Head>
                <title>
                    {config.tenantName} - {getTranslation(text.subtitle)}
                </title>
            </Head>
            <Layout>
                <div className={css.articleContent}>
                    <div className={css.article}>
                        <div className={css.elementError}>
                            <h1>{getTranslation(text.title)}</h1>
                            <h2>{getTranslation(text.subtitle)}</h2>
                            <p>{getTranslation(text.description)}</p>
                            <Link href={getCategoryUrl('')} className={css.button}>
                                {getTranslation('buttonLabel')}
                            </Link>
                        </div>
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default Error;
